import React, { PureComponent}from 'react';
import Viewers from 'common/components/viewers/Viewers';
import './NickViewers.scss';

export default class NickViewers extends PureComponent{
    render() {
        const classname = this.props.className || 'm-nickViewers ' + ( this.props.noViewer ?  'noViewer' : '') ;

        return (
            <div className={classname} >
                <div className="nick">{this.props.sNick}</div>
                {this.props.noViewer ?
                    null :
                    <Viewers number={this.props.iNumber}/>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/components/nick-viewers/NickViewers.jsx